"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactHooks = require("@apollo/react-hooks");

var _ADD_NEW_USER = _interopRequireDefault(require("../graphql/ADD_NEW_USER"));

var _BluekeelPixel = _interopRequireDefault(require("../utils/BluekeelPixel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useInsertNewUser = function useInsertNewUser(tracking, hsid, ip_address, shouldExecute) {
  var _useMutation = (0, _reactHooks.useMutation)(_ADD_NEW_USER.default, {
    onCompleted: function onCompleted(data) {
      return console.log(data.addNewUser.message);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addNewUser = _useMutation2[0];

  var createNewUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              addNewUser({
                variables: {
                  visitor: {
                    clickId: hsid,
                    ip_address: ip_address,
                    program: {
                      pid: tracking['pid'],
                      oid: tracking['oid'],
                      eid: tracking['eid'],
                      sid: tracking['sid'],
                      uid: tracking['uid']
                    }
                  }
                }
              });

              if (tracking['sid'] === 5102 || tracking['sid'] === 9113 || tracking['sid'] === 9371 || tracking['sid'] === 9419) {
                (0, _BluekeelPixel.default)(hsid);
              }

              ;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createNewUser() {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (shouldExecute) {
      createNewUser();
    }

    ; // eslint-disable-next-line
  }, [shouldExecute]);
  return;
};

var _default = useInsertNewUser;
exports.default = _default;

//# sourceMappingURL=useInsertUser.jsx.map